var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 53.125,
    fill: "#d33865"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 6,
    ry: 6,
    fill: "#fff",
    stroke: "#fff",
    "transform-origin": "111.104px 22.136px",
    height: 9.503,
    x: 77.402,
    y: 17.582,
    width: 67,
    transform: "matrix(0.707161, 0.707053, -0.707053, 0.707161, -52.321515, 36.36716)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    rx: 6,
    ry: 6,
    fill: "#fff",
    stroke: "#fff",
    "transform-origin": "111.104px 22.136px",
    height: 9.503,
    x: 77.402,
    y: 17.582,
    width: 67,
    transform: "matrix(0.707053, -0.707161, 0.707161, 0.707053, -52.600842, 36.081513)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCross);
export default __webpack_public_path__ + "static/media/big-cross.e1e857241aabfe646c82b72d93ab19f1.svg";
export { ForwardRef as ReactComponent };